export const LIST_VIP = [
    {
      title: "VIP 1",
      key: "VIP1",
      value: 1
    },
    {
      title: "VIP 2",
      key: "VIP2",
      value: 2
    },
    {
      title: "VIP 3",
      key: "VIP3",
      value: 3
    },
    {
      title: "VIP 4",
      key: "VIP4",
      value: 4
    },
    {
      title: "VIP 5",
      key: "VIP5",
      value: 5
    },
    {
      title: "VIP 6",
      key: "VIP6",
      value: 6
    },
    {
      title: "VIP 7",
      key: "VIP7",
      value: 7
    }
];

export const GROUP_USER = {
  not_kyc: 'Chưa KYC',
  none_balance: 'Chưa nạp tiền',
  not_buy_gold: 'Chưa mua vàng',
  not_ref: 'Chưa giới thiệu bạn bè',
  not_invest: 'Chưa tham gia cùng hợp tác',
  not_daily_gold: 'Dưới 0,5 Chỉ Vàng',
  not_daily_money: 'Dưới 1tr VNDC',
  invested: 'Đã tham gia cùng hợp tác',
  buy_gold: 'Đã mua vàng',
  user_moonlove: 'Tham gia đầu tư gói MoonLove'
}


export const HISTORY_CHANGE_COIN_TYPE = {
  SWAP: 'SWAP',
  WIDTHDRAW: 'WIDTHDRAW',
  DEPOSIT: 'DEPOSIT',
  INVEST: 'INVEST',
  COMMISSION: 'COMMISSION',
  PURCHASE_BOX: 'PURCHASE_BOX',
  UPGRADE: 'UPGRADE',
  RENEW: 'RENEW',
  REPAIR: 'REPAIR',
  TRANSFER_ITEM: 'TRANSFER_ITEM',
  REFUND: 'REFUND',
  PURCHASE_SHOE: 'PURCHASE_SHOE',
  EXHANGE_REWARD: 'EXHANGE_REWARD',
  ONCHAIN_WITHDRAWAL: 'ONCHAIN_WITHDRAWAL',
  ONCHAIN_DEPOSIT: 'ONCHAIN_DEPOSIT',
};

export const ONCHAIN_TYPE = {
  "VNDC": "VNDC",
  "USDT": "USDT",
};

export const AUTO_CRAWL = {
  "RISE": "autoCrawlRISEPrice"
}

